// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderOnlyPage_header__3dyGm","header__inner":"HeaderOnlyPage_header__inner__37k1n","header__title":"HeaderOnlyPage_header__title__16Gga"};